import React, { memo } from 'react'
import { advertiserCampaignMenu } from '../../data/Menu'
import { Badge } from 'react-bootstrap'
import PopulateMenu from './PopulateMenu'

const dotClassMap = {
    active: 'active-campaign-dot',
    inactive: 'inactive-campaign-dot',
    paused: 'paused-campaign-dot'
}

const CampaignsMenu = ({ isCampaignsOpened, toggleCampaigns, menuName, campaigns, advertiserId, onUpdateSize, language }) => {
    const currentUrlParams = new URLSearchParams(window.location.search)
    const pubValue = currentUrlParams.get('pub')
    let menuToRender = advertiserCampaignMenu
    if (Number(pubValue) !== 67) {
        menuToRender = advertiserCampaignMenu.filter(item => item.label.EN !== 'Interval Auctions')
    }
    return (
        <div className={`nav-group ${isCampaignsOpened ? 'show' : ''}`}>
            <div className="nav-label" onClick={toggleCampaigns}>
                {menuName}
            </div>

            {isCampaignsOpened &&
                campaigns.map((campaign, key) => {
                    const updatedMenu = menuToRender.map(m => {
                        const baseLink = m.link.includes('campaignId') ? m.link.split('?')[0] : m.link
                        return {
                            ...m,
                            link: `${baseLink}?campaignId=${campaign.id}&pub=${pubValue}`
                        }
                    })

                    return (
                        <div key={key}>
                            <div className="campaign-nav-label">
                                <div className="d-flex flex-column">
                                    <Badge
                                        bg="campaign-name"
                                        className="me-1 bg-campaign-name"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 6,
                                            width: 'max-content',
                                            maxWidth: '180px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            pointerEvents: 'none'
                                        }}
                                    >
                                        <span className={`${dotClassMap[campaign.status]}`}></span>
                                        {campaign.name}
                                    </Badge>
                                </div>
                            </div>
                            <PopulateMenu menuItems={updatedMenu} advertiserId={advertiserId} onUpdateSize={onUpdateSize} language={language} />
                        </div>
                    )
                })}
        </div>
    )
}

export default memo(CampaignsMenu)
